"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNotBlank = exports.InvalidArgumentError = void 0;
class InvalidArgumentError extends Error {
}
exports.InvalidArgumentError = InvalidArgumentError;
function validateNotBlank(value, errorMessage) {
    if (value == null || value.length === 0) {
        throw new InvalidArgumentError(errorMessage);
    }
}
exports.validateNotBlank = validateNotBlank;
//# sourceMappingURL=validation.js.map